

























import { Component, Prop, Vue } from "vue-property-decorator";
import ComparisonGroupEditor from "./ComparisonGroupEditor.vue";
import { ComparisonGroup } from "@/models";

const DEFAULT_PLACEHOLDER = "Selezionare un gruppo";

@Component({
  components: {
    ComparisonGroupEditor,
  },
})
export default class ComparisonGroupSelect extends Vue {
  @Prop() readonly value!: ComparisonGroup | null;
  @Prop({ default: DEFAULT_PLACEHOLDER }) readonly placeholder?: string;
  @Prop({ default: true }) readonly selectLast?: boolean;

  visible = false;
  enabled = false;

  selected: ComparisonGroup | null = null;

  get label(): string {
    if (this.selected == null) {
      return this.placeholder || DEFAULT_PLACEHOLDER;
    }

    return this.selected.name + ` (${this.selected.elementsCount})`;
  }

  get componentClass() {
    return {
      "comparison-group-select--disabled": this.enabled == false,
    };
  }

  created() {
    this.selected = this.value?.clone();
  }

  toggleDropdown() {
    if (this.enabled === false) {
      return;
    }

    this.visible = !this.visible;
  }

  closeDropdown() {
    if (this.visible) {
      this.visible = false;
    }
  }

  emitValue() {
    this.$emit("input", this.selected?.clone());
  }

  onReady() {
    this.enabled = true;

    if (this.selectLast) {
      const group = localStorage.getItem(`${this.$options.name}-group`);

      if (group) {
        (this.$refs.editor as ComparisonGroupEditor).selectById(group);
      }

      if (!this.selected) {
        (this.$refs.editor as ComparisonGroupEditor).selectFirst();
      }
    } else {
      (this.$refs.editor as ComparisonGroupEditor).selectFirst();
    }

    this.$emit("ready");
  }

  onSelected(group: ComparisonGroup) {
    this.selected = group;
    this.emitValue();

    localStorage.setItem(`${this.$options.name}-group`, group.id);
  }
}
